import api from './api';

export interface OfficialPromptTemplate {
  strategy: 'smc' | 'ict' | 'price_action' | 'fibonacci';
  name: string;
  version: number;
}

export const promptTemplatesService = {
  async listOfficial(): Promise<OfficialPromptTemplate[]> {
    const res = await api.get<OfficialPromptTemplate[]>('/prompt-templates');
    return res.data;
  },
};
